import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { CardComponent } from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import NotificationCard, {
  NotificationCardProps,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components/molecules/NotificationCard';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import React from 'react';
import NoNotify from '../NoNotify';
import VariableListboxComponent from '../VariableSizeList';

export interface NotificationTimeLineProps {
  notifications: NotificationCardProps[];
  title: string;
  width: string;
  newNotificationCount: Number;
  isHomeScreen: boolean;
  handleItemsRendered: ({
     
    visibleStopIndex,
  }: {
    visibleStopIndex: number;
  }) => void;
}
const useStyles = makeStyles()({
  titleContainer: {
    display: 'flex',
    gap: '1rem',
    alignItems: 'center',
    padding: '0 24px',
  },
  notificationMainContent: {
    height: '550px',
  },
  notificationCount: {
    backgroundColor: '#D6545E',
    height: '20px',
    width: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
  },
  notificationCardContainer: {
    borderBottom: '1px solid #E5E9F0',
    width: '100%',
    padding: '12px 16px 0px 16px',
  },
  noNotificationData: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '300px',
  },
});
const NotificationTimeLine: React.FC<NotificationTimeLineProps> = ({
  notifications,
  title,
  width,
  isHomeScreen,
  handleItemsRendered,
}) => {
  const { classes } = useStyles();
  const MemoNotificationCard = React.memo(NotificationCard);
  return (
    <CardComponent
      title={
        <Grid className={classes.titleContainer}>
          <Typography fontType="semiBold">{title}</Typography>
        </Grid>
      }
      body={
        <Grid className={classes.notificationMainContent}>
          {notifications?.length > 0 ? (
            <VariableListboxComponent
              maxHeight={550}
              estimatedItemSize={250}
              overscanCount={8}
              handleItemsRendered={handleItemsRendered}
            >
              {notifications.map((card, index) => (
                <div key={index} className={classes.notificationCardContainer}>
                  <MemoNotificationCard {...card} isHomeScreen={isHomeScreen} />
                </div>
              ))}
            </VariableListboxComponent>
          ) : (
            <Grid className={classes.noNotificationData}>
              <NoNotify label={'No Insights & Notifications Available !'} />
            </Grid>
          )}
        </Grid>
      }
      mainGridStyles={{ width, padding: '24px 0', minHeight: '630px' }}
    />
  );
};

export default NotificationTimeLine;
